import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-documents-header',
  templateUrl: './documents-header.component.html',
  styleUrls: ['./documents-header.component.css']
})
export class DocumentsHeaderComponent implements OnInit {
  activetabcat = 0;
  @Input() documenttab = 0;
  visableCloseDocument: boolean = false;
  constructor(private _activeRoute: ActivatedRoute) {

    if (sessionStorage.getItem("hideDocumentsHeader") != null && sessionStorage.getItem("hideDocumentsHeader") != undefined) {
      this.visableCloseDocument = true;
    } else {
      this.visableCloseDocument = false;
    }
  }

  ngOnInit() {
    // alert('Document Header component calls')
    this._activeRoute.queryParams.subscribe(res => {
      if (res) {
        this.activetabcat = res.activeTab;
      }
    });

  }
  onLinkClick(event: MatTabChangeEvent) {
    //alert(event.index);
    this.documenttab = event.index;
    // event.tab.isActive = true;
    // this.router.navigateByUrl('/' + event.tab.textLabel);
  }
  @Output() DocumentSilderClose = new EventEmitter<string>();
  CloseDocument() {
    sessionStorage.removeItem("AlertsheaderIconVisibility");
    sessionStorage.removeItem("fromscreen");
    this.DocumentSilderClose.emit()
  }
}
